// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__2gvsQ","container":"styles_container__33Yfe","createType":"styles_createType__p-IL0","submitModal":"styles_submitModal__3WsyE"};